$(function () {
    $('select:not(.no-ready)').chosen({disable_search_threshold: 10});
});
